// extracted by mini-css-extract-plugin
module.exports = {"content":"Customization_content__3sF5U","submitBtn":"Customization_submitBtn__1OhIk"};